module.exports = __webpack_public_path__ + "img/office-3.1f575764.jpg";